import GuestsSelectorMobile from './GuestsSelectorMobile';

export default GuestsSelectorMobile;
